import _ from 'lodash';
import NavBarBaseCtrl from './NavBarBaseCtrl';

export default ['$scope', '$element', ($scope, $element) => {
    const ctrl = new NavBarBaseCtrl($scope, $element);

    ctrl.init = () => {
        $scope.currentTab = _.constant('none');
        $scope.displayAddPolicyLink = _.constant(false);
    };

    return ctrl.create($scope);
}];
